<script lang="ts" setup>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Logo from '~/assets/images/logo.svg?component'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Search from '~/assets/images/search.svg?component'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import More from '~/assets/images/more.svg?component'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Close from '~/assets/images/close.svg?component'
import PLink from '~/components/PLink.vue'
import PButton from '~/components/PButton.vue'

const router = useRouter()
const selection = ref()
const { t } = useI18n()

const navigation = [
    { id: 'top-nav-search', title: t('search'), to: '/search' },
    { id: 'top-nav-studies', title: t('studies'), to: '/studies' },
    { id: 'top-nav-talks', title: t('talks'), to: '/talks' },
    { id: 'top-nav-articles', title: t('articles'), to: '/articles' },
    { id: 'top-nav-workship', title: t('worship'), to: '/worship' },
]

function updateSelection() {
    selection.value = null
    for (const nav of navigation) {
        if (router.currentRoute.value.path.startsWith(nav.to)) {
            selection.value = nav.to
        }
    }
}

watch(router.currentRoute, updateSelection)

defineProps<{
  isOpen: boolean
  toggleOpen: () => void
  close: () => void
}>()

const links = ref<HTMLElement | undefined>()

onMounted(() => {
    updateSelection()
})
</script>

<template>
  <nav
    :class="
      'rounded-lg md:rounded-none bg-white/15 dark:bg-gray-800/60 px-4 py-1 md:p-4 z-10 transition-all ease-in duration-150'
        + (isOpen ? ' bg-white/100' : ' topbar')
    "
  >
    <div class="grid grid-cols-3 justify-items-center justify-between gap-6">
      <div class="ms-2 md:ms-4 w-full flex justify-start items-center">
        <PLink
          id="hdr-search"
          type="button"
          to="/search"
          class="flex fill-black hover:fill-blurple-700 text-black hover:text-blurple-700"
          :click="close"
        >
          <Search
            :class="
              'w-6 h-6 '
                + (selection === '/search' ? ' fill-blurple-600' : '')
            "
          />
          <div
            :class="
              'ms-2 hidden md:block '
                + (selection === '/search' ? ' text-blurple-600' : '')
            "
          >
            {{ $t('search') }}
          </div>
        </PLink>
      </div>
      <div class="ms-2 md:ms-4 w-full flex justify-center items-center">
        <PLink
          id="hdr-home"
          type="button"
          to="/"
          :click="close"
        >
          <span class="sr-only">{{ $t('passionEquipHome') }}</span>
          <Logo class="h-6 md:h-8 fill-black dark:fill-white" />
        </PLink>
      </div>
      <div class="me-2 md:me-8 w-full flex justify-end items-center">
        <div
          ref="links"
          class="hidden md:flex me-8 gap-6"
        >
          <PLink
            id="hdr-top-menu-studies-link"
            type="button"
            to="/studies"
            :class="
              (selection === '/studies'
                ? 'text-blurple-600 dark:text-blurple-300'
                : '') + ' hover:text-blurple-700'
            "
            :click="close"
          >
            {{ $t('studies') }}
          </PLink>
          <PLink
            id="hdr-top-menu-messages-link"
            type="button"
            :class="
              (selection === '/talks'
                ? 'text-blurple-600 dark:text-blurple-300'
                : '') + ' hover:text-blurple-700'
            "
            to="/talks"
            :click="close"
          >
            {{ $t('talks') }}
          </PLink>
          <PLink
            id="hdr-top-menu-articles-link"
            type="button"
            to="/articles"
            :class="
              (selection === '/articles'
                ? 'text-blurple-600 dark:text-blurple-300'
                : '') + ' hover:text-blurple-700'
            "
            :click="close"
          >
            {{ $t('articles') }}
          </PLink>
          <PLink
            id="hdr-top-menu-songs-link"
            type="button"
            to="/worship"
            :class="
              (selection === '/worship'
                ? 'text-blurple-600 dark:text-blurple-300'
                : '') + ' hover:text-blurple-700'
            "
            class="hidden min-[1200px]:grid"
            :click="close"
          >
            {{ $t('worship') }}
          </PLink>
        </div>
        <PButton
          id="hdr-menu-more-button"
          type="button"
          class="relative w-10 h-10 flex justify-end items-center stroke-black hover:stroke-blurple-700"
          :extras="{ action: isOpen ? 'close' : 'open' }"
          :click="toggleOpen"
        >
          <span class="sr-only">{{ $t('more') }}</span>
          <More
            :class="
              'absolute w-6 h-6 stroke-inherit transition-opacity'
                + (isOpen ? ' opacity-0' : ' opacity-100')
            "
          />
          <Close
            :class="
              'absolute w-6 h-6 stroke-inherit transition-opacity'
                + (!isOpen ? ' opacity-0' : ' opacity-100')
            "
          />
        </PButton>
      </div>
    </div>
  </nav>
</template>
